import { WorkerStatuses } from '../../../core/openapi/bff-admin-api';

const classByStatusMap: Partial<Record<WorkerStatuses, string>> = {
  [WorkerStatuses.Active]: 'green',
  [WorkerStatuses.Disabled]: 'gray',
};

export const classByStatus = (currentStatus: WorkerStatuses | undefined): string => {
  if (currentStatus == null) return 'orange';

  return classByStatusMap[currentStatus] ?? 'orange';
};
